import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      success: true,
      phone: '0545****325',
    },
    status: 200,
  },

  error: {
    response: {
      createdAt: 1701115461239,
      object: 'login',
      success: false,
    },
    status: 500,
  },
};

const loginHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(2000);
  return HttpResponse.json(response, status);
};

export {
  loginHandler,
};
